import React from 'react';
import './PageBanner.css';

const PageBanner = (props) => {
  
  //Imagen de Fondo via props
  const bgImg = props.img ? `/images/${props.img}` : '/images/banner.jpg';

  const bg = {
    padding: '5% 10% 5% 8%',
    backgroundImage: `linear-gradient( rgba(0,0,0,0.5), rgba(0, 0, 0, 0.5) ), url("${bgImg}")`,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover'
  }

  return (
  <div className='contenedor-banner' style={bg}>
      <h1>{props.title}</h1>
        <ol className="breadcrumb">
          {props.children && props.children.map((c,index)=>
            <li key={`link${index}`} className="breadcrumb-item">{c}</li>
          )}
        </ol>
  </div>
)};

export default PageBanner;
